/** Числа, склонения и «эквиваленты» из плиток «За всё время». */
const NBSP = ' ';
/** «18 600» — разряды неразрывным пробелом. */
export function formatNumber(value, fractionDigits = 0) {
    const fixed = value.toFixed(fractionDigits);
    const [intPart, frac] = fixed.split('.');
    const grouped = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, NBSP);
    return frac ? `${grouped},${frac}` : grouped;
}
/** «62,5» — вес и граммы пишем с запятой и без лишних нулей. */
export function formatDecimal(value, maxFractionDigits = 1) {
    const rounded = Number(value.toFixed(maxFractionDigits));
    return formatNumber(rounded, Number.isInteger(rounded) ? 0 : maxFractionDigits);
}
/** Русское склонение: plural(3, 'слон', 'слона', 'слонов') → 'слона'. */
export function plural(n, one, few, many) {
    const abs = Math.abs(Math.round(n));
    const mod10 = abs % 10;
    const mod100 = abs % 100;
    if (mod100 >= 11 && mod100 <= 19)
        return many;
    if (mod10 === 1)
        return one;
    if (mod10 >= 2 && mod10 <= 4)
        return few;
    return many;
}
export function pluralize(n, one, few, many) {
    return `${formatNumber(n)}${NBSP}${plural(n, one, few, many)}`;
}
/**
 * Константы эквивалентов. SPEC §10 п.6 помечает их как «подобрать» —
 * держим в одном месте, чтобы заказчик мог поправить одним числом.
 */
export const EQUIVALENTS = {
    /** Взрослый африканский слон. */
    elephantKg: 6000,
    /** Суточный рацион большой белой акулы. */
    sharkKcalPerDay: 4800,
};
/** «≈ 3 африканских слона» / «Ещё 1 200 кг до слона». */
export function liftedEquivalent(totalKg) {
    const count = Math.floor(totalKg / EQUIVALENTS.elephantKg);
    if (count < 1) {
        const left = EQUIVALENTS.elephantKg - totalKg;
        return `Ещё ${formatNumber(Math.max(0, Math.round(left)))}${NBSP}кг до слона`;
    }
    return `≈ ${formatNumber(count)}${NBSP}${plural(count, 'африканский слон', 'африканских слона', 'африканских слонов')}`;
}
/** «Акула ест это 12 дней». */
export function eatenEquivalent(totalKcal) {
    const days = Math.floor(totalKcal / EQUIVALENTS.sharkKcalPerDay);
    if (days < 1)
        return 'Акуле хватит меньше чем на день';
    return `Акула ест это ${formatNumber(days)}${NBSP}${plural(days, 'день', 'дня', 'дней')}`;
}
/** «45 мин» / «1 ч 15 мин». */
export function formatDuration(minutes) {
    if (minutes < 60)
        return `${minutes}${NBSP}мин`;
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    return m ? `${h}${NBSP}ч ${m}${NBSP}мин` : `${h}${NBSP}ч`;
}
/** Первая буква имени для аватара-заглушки. */
export function initial(name) {
    return (name.trim()[0] ?? '?').toUpperCase();
}
/** «Мария Смирнова» → «Мария С.» — как в таблице лиги. */
export function shortName(name) {
    const parts = name.trim().split(/\s+/);
    if (parts.length < 2)
        return parts[0] ?? name;
    return `${parts[0]} ${parts[1][0].toUpperCase()}.`;
}
//# sourceMappingURL=format.js.map